interface TranslationButtonProps {
    className?: string;
    id?: string;
    label?: string;
    onClick?: () => void;
}

/**
 * A button for performing various actions (submit, open, close, cancel, etc)
 * @name TranslationButton
 * @param className
 * @param id
 * @param label
 * @param onClick
 * @return {JSX.Element}
 * @constructor
 */
const TranslationButton = ({ className, id, label, onClick }: TranslationButtonProps): React.JSX.Element => {
    return (
        <button className={className} id={id} onClick={onClick} tabIndex={0} type="button">
            {label}
        </button>
    );
};

export default TranslationButton;
